<template>
    <tr>
        <td class="text-center">
            <span class="ix-drag-icon handle-line"></span>
        </td>
        <td class="text-center">
            <input type="checkbox" value="1" :id="'is_title_' + purchase.uniq" :name="'purchases[' + index + '][is_title]'" v-model="purchase.is_title" @change="isTitleChange">
        </td>
        <td>
            <input type="text" class="form-control form-control-sm" :name="'purchases[' + index + '][reference]'" v-model="purchase.reference">
        </td>
        <td>
            <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control form-control-sm" :id="'suggestionAutocomplete' + purchase.uniq" type="text" :name="'purchases[' + index + '][designation]'" v-model="purchase.designation" @input="emitEeventLineEdited">
            <button type="button" tabindex="-1" class="ix-btn link" @click="manageAssociations()" v-if="purchase.quantity > 0 && purchase.designation && purchase.is_title != 1">
                <i class="far fa-chevron-right"></i> Ventilations
                <span v-if="purchase.deal_associations.length > 0">({{ purchase.deal_associations.length }})</span>
                <span v-if="purchase.intervention_associations.length > 0">({{ purchase.intervention_associations.length }})</span>
            </button>
            <input type="hidden" :name="'purchases[' + index + '][id]'" v-model="purchase.id">
            <input type="hidden" :name="'purchases[' + index + '][article_id]'" v-model="purchase.article_id" :id="'article' + purchase.uniq">
            <div  v-if="purchase.quantity > 0 && purchase.designation && purchase.is_title != 1">
                <span class="ix-badge blue"> {{ purchase.quantity - total_associations}} / {{purchase.quantity}}</span> {{ purchase.article_id ? 'Stock' : 'Frais généraux' }}  
            </div>
            <div v-for="(association, i) in purchase.deal_associations">
               <span class="ix-badge blue">  {{ association.quantity }} / {{ purchase.quantity }}   </span> {{ association.deal_designation }} <span v-if="association.lot_id!= null && association.lot_designation"> {{ association.lot_designation }}</span>
                <input type="hidden" :name="'purchases[' + index + '][deal_associations][' + i + '][deal_id]'" v-model="association.deal_id">
                <input type="hidden" :name="'purchases[' + index + '][deal_associations][' + i + '][deal_designation]'" v-model="association.deal_designation">
                <input type="hidden" :name="'purchases[' + index + '][deal_associations][' + i + '][quantity]'" v-model="association.quantity">
                <input type="hidden" :name="'purchases[' + index + '][deal_associations][' + i + '][lot_id]'" v-model="association.lot_id">
                <input type="hidden" :name="'purchases[' + index + '][deal_associations][' + i + '][lot_designation]'" v-model="association.lot_designation">
            </div>

             <div v-for="(association, i) in purchase.intervention_associations">
              <span class="ix-badge blue">  {{ association.quantity }} / {{ purchase.quantity }}   </span>{{ association.intervention_designation }}  
                <input type="hidden" :name="'purchases[' + index + '][intervention_associations][' + i + '][intervention_id]'" v-model="association.intervention_id">
                <input type="hidden" :name="'purchases[' + index + '][intervention_associations][' + i + '][intervention_designation]'" v-model="association.intervention_designation">
                <input type="hidden" :name="'purchases[' + index + '][intervention_associations][' + i + '][quantity]'" v-model="association.quantity">
            </div>

            <div v-show="is_expanded === true">
                <textarea rows="2" class="form-control form-control-sm mt-2" placeholder="description, informations complémentaires, .." :name="'purchases[' + index + '][description]'" v-model="purchase.description"></textarea>
                <select :name="'purchases[' + index + '][type]'" v-model="purchase.type" class="form-control form-control-sm mt-2" required>
                    <option v-for="(type, value) in types" :value="value">{{ type.label }}</option>
                </select>
            </div>
        </td>
        <td :colspan="isAutoliquidation == 1 ? 4 : 5" v-if="purchase.is_title == 1"></td>
        <td v-if="purchase.is_title != 1">
            <input type="number" class="form-control form-control-sm" :name="'purchases[' + index + '][quantity]'" v-model="purchase.quantity" @blur="compute" required step="0.001">
            <input type="text" class="form-control form-control-sm mt-2" placeholder="unité" :name="'purchases[' + index + '][unit]'" v-model="purchase.unit" v-show="is_expanded === true">
        </td>
        <td v-if="purchase.is_title != 1">
            <div class="input-group input-group-sm">
                <input type="number" class="form-control text-right" :name="'purchases[' + index + '][amount]'" v-model="purchase.amount" @blur="compute" required step="0.001">
                <div class="input-group-append">
                    <span class="input-group-text" id="inputGroup-sizing-sm">€</span>
                </div>
            </div>
        </td>
        <td v-if="purchase.is_title != 1">
            <div class="input-group input-group-sm">
                <input type="number" class="form-control text-center" :name="'purchases[' + index + '][discount]'" v-model="purchase.discount" @blur="compute" required min="0" step="0.01">
                <div class="input-group-append">
                    <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                </div>
            </div>
        </td>
        <td class="text-right" v-if="purchase.is_title != 1">{{ currency(purchase.total_ht) }}</td>
        <td v-if="purchase.is_title != 1 && isAutoliquidation != 1">
            <div class="input-group input-group-sm">
                <input type="number" class="form-control text-center" :name="'purchases[' + index + '][vat]'" v-model="purchase.vat" @blur="compute" required min="0" step="0.01">
                <div class="input-group-append">
                    <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                </div>
            </div>
        </td>
        <td class="text-right">
            <span class="btn btn-sm transparent" @click="expandRow">
                <i class="far fa-chevron-up" v-if="is_expanded === true"></i>
                <i class="far fa-chevron-down" v-if="is_expanded === false"></i>
            </span>

            <span class="btn btn-sm transparent" @click="emitEventLineDeleted">
                <i class="far fa-trash"></i>
            </span>
        </td>
    </tr>
</template>

<script>
    import $ from 'jquery'
    import Swal from "sweetalert2";

    export default {
        name: 'purchase-form',
        props: ['purchase', 'index', 'discount', 'isAutoliquidation', 'suggestionsRoute', 'model', 'id', 'types', 'tva'],
        data() {
            return {
                errors: [],
                is_expanded: false,
                suggestions: [],
                globalTva: this.tva
            };
        },
        computed: {
            total_associations: function() {
                var sum = 0;
                this.purchase.deal_associations.forEach(association => {
                    if (association.quantity != '' && association.quantity != null) {
                        sum += parseFloat(association.quantity)
                    }
                })
                return sum;
            }
        },
        watch: {
            discount: function () {
                this.compute();
            },
            isAutoliquidation: function (newVal, oldVal) {
                if (newVal == 1) {
                    this.purchase.vat = 0;
                    this.compute();
                }
            }
        },
        methods : {
            manageAssociations(){
                this.$emit('purchase-manage-associations-started', this.index)
            },
            expandRow: function() {
                this.is_expanded = !this.is_expanded;
            },
            isTitleChange: function() {
                if (this.purchase.is_title) {
                    this.purchase.deal_associations = []
                }
                this.compute()
            },
            compute: function() {
               
                // Prévention champs vide
                if (this.purchase.quantity == '' || this.purchase.quantity == null) { this.purchase.quantity = 0 }
                if (this.purchase.amount == '' || this.purchase.amount == null) { this.purchase.amount = 0 }
                if (this.purchase.discount == '' || this.purchase.discount == null) { this.purchase.discount = 0 }
                if ((this.purchase.vat == '' || this.purchase.vat == null) && !this.purchase.is_title) {
                     this.purchase.vat =  this.globalTva ?  this.globalTva : 0 
                }

                if (this.purchase.is_title) {
                    this.purchase.article_id =  null;
                    this.purchase.quantity = 1;
                    this.purchase.unit = null;
                    this.purchase.amount = 0;
                    this.purchase.discount = 0;
                    this.purchase.total_ht = 0;
                    this.purchase.total_discount = 0;
                    this.purchase.total_after_discount = 0;
                    this.purchase.total_vat = 0;
                    this.purchase.total_ttc = 0;
                } else {
                    var price = parseFloat(this.purchase.quantity) * parseFloat(this.purchase.amount);
                    var discount = parseFloat(this.purchase.discount) !== 0 ? ((price / 100) * parseFloat(this.purchase.discount)) : 0;
                    this.purchase.total_ht = price - discount;

                    if (this.discount) {
                        this.purchase.total_discount = (this.purchase.total_ht / 100) * this.discount;
                        this.purchase.total_after_discount = this.purchase.total_ht - this.purchase.total_discount;
                    } else {
                        this.purchase.total_discount = 0;
                        this.purchase.total_after_discount = this.purchase.total_ht;
                    }

                    this.purchase.total_vat = (this.purchase.total_after_discount / 100) * this.purchase.vat;
                    this.purchase.total_ttc = this.purchase.total_after_discount + this.purchase.total_vat;
                }

                
                if (this.purchase.quantity < this.total_associations) {
                    this.manageAssociations()
                }
            },
            emitEeventLineEdited: function () {
                this.$emit('purchase-editing-started', this.index)
            },
            emitEventLineDeleted: function () {
                Swal.fire({
                    title: 'Êtes-vous sûr ?',
                    text: "",
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Annuler',
                    confirmButtonColor: '#D15240',
                    confirmButtonText: 'Oui, supprimer',
                    reverseButtons: true,
                    heightAuto: false
                }).then((result) => {
                    if (result.value) {
                        this.$emit('purchase-deleted', this.index)
                    }
                })
            }
        },
        mounted() {
            // Expand si description
            if (this.purchase.description) {
                this.is_expanded = true;
            }

            this.compute()

            // Creation autocomplete
            $("#suggestionAutocomplete" + this.purchase.uniq).autocomplete({
                minLength: 2,
                source: (request, response) => {
                    $.ajax({
                        url : this.suggestionsRoute,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: {...{ q: request.term, expense_id: this.expense_id }, ...{company_id: $('#company_id').val()}},
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.designation,
                                    value: item.designation,
                                    formatted_amount: this.currency(item.amount)
                                })
                            }))
                        }
                    });
                },
                create: function () {
                    $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                        if (item.provider != null) {
                            var html = `<div class="d-flex align-items-center ix-text-small ix-suggestion-small">
                                              <span><i class="far fa-level-up fa-rotate-90"></i> Vendu par ${item.provider} ${item.is_favorite ? '<span class="ix-text-yellow"><i class="far fa-star"></i></span>' : ''} ${item.reference ? '- ' + item.reference : ''} ${item.indications ? '- ' + item.indications : ''}</span>
                                              <span class="ml-auto">${item.formatted_amount}</span>
                                          </div>`
                        } else {
                            var html = `<div class="d-flex align-items-center">
                                              <span>${item.designation}</span>
                                              <span class="ml-auto">${item.number ? item.number : ''} ${item.number && item.ean ? ' - ' : ''} ${item.ean ? item.ean : ''}</span>
                                          </div>`
                        }

                        return $('<li>')
                            .append(html)
                            .appendTo(ul);
                    };
                },
                change: (e, item) => {
                    if (!item.item) {
                        this.purchase.article_id = ''
                        $("#article" + this.purchase.uniq).val('')
                    }
                },
                select: (e, item) => {
                    this.purchase.article_id = item.item.article_id
                    this.purchase.reference = item.item.reference &&  item.item.reference != null ? item.item.reference : item.item.number
                    this.purchase.designation = item.item.designation
                    this.purchase.unit = item.item.unit
                    this.purchase.amount = item.item.amount
                    this.purchase.description = item.item.description
                    this.purchase.is_title = false
                    if (this.purchase.description) {
                        this.is_expanded = true;
                    }
                    console.log(item.item);

                    this.compute()
                }
            }).focus(() => {
                $("#suggestionAutocomplete" + this.purchase.uniq).autocomplete("search", '');
            });
        }
    }
</script>
